import { uuidv4 } from '@holmescorp/uuid';
import { DateTime, Duration } from 'luxon';
export const Utils = {
    defaultEncoding: 'utf8',
    get uuid() {
        return uuidv4();
    },
    getUUID() {
        return uuidv4();
    },
    calculateISO8601Duration(startDate, endDate) {
        if (startDate instanceof Date) {
            startDate = DateTime.fromJSDate(startDate);
        }
        if (endDate instanceof Date) {
            endDate = DateTime.fromJSDate(endDate);
        }
        return endDate.diff(startDate).normalize().toISO() ?? undefined;
    },
    getISODateString(d) {
        if (d === undefined) {
            return DateTime.utc().toISO() ?? undefined;
        }
        return DateTime.fromJSDate(d).toISO() ?? undefined;
    },
    get isoNow() {
        return DateTime.utc().toISO() ?? undefined;
    },
    convertISO8601DurationToMilliseconds(ISO8601Duration) {
        return Duration.fromISO(ISO8601Duration).toMillis();
    },
    convertMillisecondsToISO8601Duration(inputMilliseconds) {
        return Duration.fromMillis(inputMilliseconds).toISO() ?? undefined;
    },
    getLangDictionaryValue(prop, lang) {
        const langDict = this[prop];
        let key;
        if (typeof lang !== 'undefined' && typeof langDict[lang] !== 'undefined') {
            return langDict[lang];
        }
        if (typeof langDict.und !== 'undefined') {
            return langDict.und;
        }
        if (typeof langDict['en-US'] !== 'undefined') {
            return langDict['en-US'];
        }
        for (key in langDict) {
            if (langDict[key]) {
                return langDict[key];
            }
        }
        return '';
    },
    stringToArrayBuffer(content) {
        return new TextEncoder().encode(content).buffer;
    },
    stringFromArrayBuffer(content) {
        return new TextDecoder().decode(content);
    }
};
